import { useState } from 'react'

import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'
import { GqlError } from 'src/lib/gql-client'
import useSWR from 'swr'

import {
  GeneratePatientVideoCallTokenReturn,
  generatePatientVideoCallToken,
} from '../api/generatePatientVideoCallToken'

type State = {
  token: string
  videoCallUserUid: number
  screenShareUserUid: number
  screenShareToken: string
  videoCallRoomUid: string
  agoraCloudProxyMode: 'Auto' | 'ForceUDP' | 'ForceTCP'
}

export const usePatientVideoCallToken = ({
  patientVideoCallUid,
}: {
  patientVideoCallUid: string
}) => {
  const [state, setState] = useState<State>()

  const toast = useMirohaToast()

  useSWR<GeneratePatientVideoCallTokenReturn, GqlError>(
    !!state ? null : { patientVideoCallUid },
    generatePatientVideoCallToken,
    {
      onSuccess: data => {
        setState({
          token: data.token,
          videoCallUserUid: data.videoCallUserUid,
          screenShareUserUid: data.screenShareUserUid,
          screenShareToken: data.screenShareToken,
          videoCallRoomUid: data.videoCallRoomUid,
          agoraCloudProxyMode: data.agoraCloudProxyMode,
        })
      },
      onError: error => {
        toast({
          status: 'error',
          title: error.message,
        })
      },
      errorRetryCount: 1,
    },
  )

  return state
}
